import { Service, CaseStudy, BlogPost, Testimonial, Stats, TimelineStep, Feature, NavItem, FooterLink, SocialLink } from './types'

export const services: Service[] = [
  // Development Services
  {
    id: 'full-stack',
    title: 'Full-Stack Development',
    description: 'End-to-end development with Java, React, Node.js, and modern frameworks.',
    icon: 'Code',
    category: 'development',
    features: ['Java', 'React', 'Node.js', 'Modern Frameworks'],
    link: '/development#full-stack'
  },
  {
    id: 'microservices',
    title: 'Scalable Microservices Architecture',
    description: 'Design and implement scalable, resilient microservices systems.',
    icon: 'Network',
    category: 'development',
    features: ['Service Mesh', 'API Gateway', 'Load Balancing', 'Circuit Breakers'],
    link: '/development#microservices'
  },
  {
    id: 'api-development',
    title: 'RESTful APIs and Secure API Development',
    description: 'Build secure, scalable APIs with industry best practices.',
    icon: 'Api',
    category: 'development',
    features: ['REST', 'GraphQL', 'Authentication', 'Rate Limiting'],
    link: '/development#api-development'
  },
  {
    id: 'frontend',
    title: 'Modern Frontend Frameworks',
    description: 'ReactJS, Electron.js, and cutting-edge frontend technologies.',
    icon: 'Monitor',
    category: 'development',
    features: ['ReactJS', 'Electron.js', 'TypeScript', 'State Management'],
    link: '/development#frontend'
  },
  {
    id: 'cloud-integration',
    title: 'Cloud Integration',
    description: 'AWS, Docker, Kubernetes deployment and management.',
    icon: 'Cloud',
    category: 'development',
    features: ['AWS', 'Docker', 'Kubernetes', 'CI/CD'],
    link: '/development#cloud-integration'
  },
  {
    id: 'cicd',
    title: 'CI/CD Pipelines',
    description: 'Efficient deployment pipelines for rapid, reliable releases.',
    icon: 'GitBranch',
    category: 'development',
    features: ['Jenkins', 'GitHub Actions', 'ArgoCD', 'Automation'],
    link: '/development#cicd'
  },
  {
    id: 'database',
    title: 'Database Optimization',
    description: 'SQL & NoSQL database design, optimization, and management.',
    icon: 'Database',
    category: 'development',
    features: ['SQL', 'NoSQL', 'Performance', 'Scalability'],
    link: '/development#database'
  },
  {
    id: 'system-design',
    title: 'High-Performance System Design',
    description: 'HLD/LLD for scalable, high-performance systems.',
    icon: 'Cpu',
    category: 'development',
    features: ['HLD', 'LLD', 'Architecture', 'Performance'],
    link: '/development#system-design'
  },
  {
    id: 'devops',
    title: 'DevOps Automation & Monitoring',
    description: 'Grafana, Prometheus, and comprehensive monitoring solutions.',
    icon: 'Gauge',
    category: 'development',
    features: ['Grafana', 'Prometheus', 'Alerting', 'Automation'],
    link: '/development#devops'
  },
  {
    id: 'ui-ux',
    title: 'User-Centric UI/UX Design',
    description: 'Intuitive, accessible user interfaces and experiences.',
    icon: 'Palette',
    category: 'development',
    features: ['UI Design', 'UX Research', 'Accessibility', 'Prototyping'],
    link: '/development#ui-ux'
  },

  // Security Services
  {
    id: 'web-pentest',
    title: 'Web Application Penetration Testing',
    description: 'OWASP Top 10 compliance and comprehensive security testing.',
    icon: 'Shield',
    category: 'security',
    features: ['OWASP Top 10', 'Vulnerability Assessment', 'Remediation'],
    link: '/security#web-pentest'
  },
  {
    id: 'network-security',
    title: 'Network Security',
    description: 'Internal & External penetration testing and security assessment.',
    icon: 'Globe',
    category: 'security',
    features: ['Internal Testing', 'External Testing', 'Network Analysis'],
    link: '/security#network-security'
  },
  {
    id: 'api-security',
    title: 'API Security Testing',
    description: 'BOLA, Mass Assignment, and comprehensive API security validation.',
    icon: 'Lock',
    category: 'security',
    features: ['BOLA', 'Mass Assignment', 'Authentication', 'Authorization'],
    link: '/security#api-security'
  },
  {
    id: 'vulnerability-assessment',
    title: 'Vulnerability Assessments and Remediation',
    description: 'Comprehensive security analysis and actionable remediation plans.',
    icon: 'Search',
    category: 'security',
    features: ['Assessment', 'Remediation', 'Risk Analysis', 'Reporting'],
    link: '/security#vulnerability-assessment'
  },
  {
    id: 'social-engineering',
    title: 'Advanced Social Engineering',
    description: 'Phishing simulations and social engineering awareness training.',
    icon: 'Users',
    category: 'security',
    features: ['Phishing Simulations', 'Training', 'Awareness', 'Testing'],
    link: '/security#social-engineering'
  },
  {
    id: 'mobile-security',
    title: 'Mobile App Security',
    description: 'Android application security testing and assessment.',
    icon: 'Smartphone',
    category: 'security',
    features: ['Android Security', 'Static Analysis', 'Dynamic Testing'],
    link: '/security#mobile-security'
  },
  {
    id: 'code-review',
    title: 'Secure Code Reviews',
    description: 'Comprehensive security-focused code analysis and recommendations.',
    icon: 'FileCode',
    category: 'security',
    features: ['Static Analysis', 'Security Patterns', 'Best Practices'],
    link: '/security#code-review'
  },
  {
    id: 'automation-tools',
    title: 'Managed Pentesting Automation Tools',
    description: 'Custom automation tools for efficient security testing.',
    icon: 'Zap',
    category: 'security',
    features: ['Custom Tools', 'Automation', 'Efficiency', 'Integration'],
    link: '/security#automation-tools'
  },
  {
    id: 'incident-response',
    title: 'Incident Response & Threat Analysis',
    description: 'Rapid response and comprehensive threat intelligence.',
    icon: 'AlertTriangle',
    category: 'security',
    features: ['Incident Response', 'Threat Analysis', 'Forensics', 'Recovery'],
    link: '/security#incident-response'
  },
  {
    id: 'compliance',
    title: 'Compliance Consulting',
    description: 'GDPR, HIPAA, PCI-DSS compliance guidance and implementation.',
    icon: 'CheckCircle',
    category: 'security',
    features: ['GDPR', 'HIPAA', 'PCI-DSS', 'Compliance'],
    link: '/security#compliance'
  }
]

export const caseStudies: CaseStudy[] = [
  {
    id: 'banking-api-hardening',
    title: 'Banking API: Zero-Downtime Release & Security Hardening',
    description: 'Migrated a high-traffic banking API to microservices with blue/green deployments and policy-as-code.',
    content: `# Banking API: Zero-Downtime Release & Security Hardening

## The Challenge

A major banking platform was struggling with their legacy monolithic API architecture. The system handled over 2 million transactions daily but faced critical issues:

- **Weekend deployment windows** causing service disruptions
- **Authentication gaps** exposing BOLA (Broken Object Level Authorization) vulnerabilities
- **Scaling bottlenecks** during peak transaction periods
- **Security audit failures** due to insufficient access controls

The platform needed a complete architectural overhaul that would maintain 99.99% uptime while implementing enterprise-grade security.

## Our Approach

We designed and implemented a comprehensive microservices architecture with security-first principles:

### 1. Domain-Driven Service Decomposition
- **User Management Service**: Authentication, authorization, and user profiles
- **Transaction Service**: Core banking operations and payment processing
- **Notification Service**: Real-time alerts and communication
- **Audit Service**: Compliance logging and monitoring

### 2. Security-First Architecture
- **Istio Service Mesh**: mTLS encryption between all services
- **JWT Authentication**: Stateless, scalable auth with proper token validation
- **OPA (Open Policy Agent)**: Policy-as-code for fine-grained authorization
- **WAF Integration**: AWS WAF with custom rules for API protection

### 3. Zero-Downtime Deployment Strategy
- **Blue/Green Deployments**: Instant rollback capability
- **Schema-First API Contracts**: OpenAPI specifications with validation
- **Chaos Engineering**: Automated failure testing and recovery drills
- **Circuit Breakers**: Automatic service isolation during failures

## Results & Outcomes

The transformation delivered exceptional results across all key metrics:

### Performance Improvements
- **P95 Latency**: Reduced by 38% (from 450ms to 280ms)
- **Deploy Frequency**: Increased 5x (from weekly to daily deployments)
- **Error Rate**: Decreased by 62% through better error handling
- **Release MTTR**: Under 15 minutes for rollbacks

### Security Enhancements
- **Zero Sev-1 Incidents**: No critical security issues post-launch
- **BOLA Prevention**: Blocked 100% of object-level authorization bypass attempts
- **Compliance**: Achieved SOC 2 Type II certification
- **Audit Readiness**: 24/7 compliance monitoring and reporting

### Business Impact
- **SLO Achievement**: 99.95% uptime maintained for 3 consecutive quarters
- **Customer Satisfaction**: 15% improvement in API response ratings
- **Operational Efficiency**: 40% reduction in infrastructure costs
- **Developer Productivity**: 3x faster feature delivery cycles

## Technology Stack

- **Backend**: Java 17, Spring Boot 3, Spring Security
- **Database**: PostgreSQL with read replicas, Redis for caching
- **Infrastructure**: AWS EKS, Application Load Balancer, WAF
- **Service Mesh**: Istio with mTLS and traffic management
- **Policy Engine**: Open Policy Agent (OPA) with Rego policies
- **Monitoring**: Prometheus, Grafana, Jaeger tracing
- **Logging**: ELK Stack (Elasticsearch, Logstash, Kibana)

## Key Metrics

- **Zero-downtime deployments**: 100% success rate over 6 months
- **Security incidents**: 0 critical, 0 high-severity
- **Performance SLO**: 99.95% uptime consistently maintained
- **Deployment frequency**: 5x increase with zero rollbacks
- **Cost optimization**: 40% reduction in infrastructure spend

This case study demonstrates how proper architectural design, security-first principles, and modern DevOps practices can transform legacy systems into highly secure, scalable, and maintainable platforms.`,
    category: 'development',
    client: 'Major Banking Platform',
    challenge: 'Legacy monolith, weekend deploys, auth gaps (BOLA risk).',
    solution: 'Cut into domain-focused services; Istio mTLS + JWT authN; OPA for authZ; WAF prefilters; schema-first contracts; chaos drills.',
    outcome: 'p95 latency −38%, deploy frequency +5x, zero Sev-1s post-launch; blocked BOLA attempts via object-level ABAC.',
    technologies: ['Java/Spring', 'Postgres', 'AWS (EKS, ALB, WAF)', 'Istio', 'OPA', 'Prometheus/Grafana', 'Loki'],
    image: '/images/case-studies/banking-api-hardening.jpg',
    slug: 'banking-api-zero-downtime-hardening',
    publishedAt: '2024-01-15'
  },
  {
    id: 'healthcare-hipaa-devsecops',
    title: 'HIPAA-Grade DevSecOps for a Healthcare Platform',
    description: 'Achieved full HIPAA compliance for healthcare data management platform with automated security controls.',
    content: `# HIPAA-Grade DevSecOps for a Healthcare Platform

## The Challenge

A healthcare technology company was struggling to achieve HIPAA compliance for their patient data management platform. The system processed sensitive health information for over 500,000 patients but faced critical compliance gaps:

- **Audit failures** for change control and secrets management
- **Slow release cycles** due to manual security reviews
- **Insufficient logging** for compliance reporting
- **Vulnerability management** gaps in the development pipeline

The platform needed a comprehensive DevSecOps transformation that would ensure HIPAA compliance while maintaining development velocity.

## Our Approach

We implemented a security-first DevSecOps pipeline with automated compliance controls:

### 1. Pipeline Security Gates
- **SAST Integration**: SonarQube with custom security rules
- **SCA Scanning**: Snyk for dependency vulnerability detection
- **IaC Security**: Conftest with OPA policies for infrastructure
- **Container Security**: Trivy and Dockle for image scanning

### 2. Secrets Management
- **KMS Integration**: AWS KMS for encryption key management
- **Secret Rotation**: Automated credential rotation every 90 days
- **Access Controls**: Role-based access with audit trails
- **Compliance Logging**: All secret access logged and monitored

### 3. Compliance Automation
- **SBOM Generation**: CycloneDX for software bill of materials
- **Audit Trails**: Comprehensive logging for all changes
- **Ephemeral Environments**: Isolated testing environments
- **DAST Testing**: Automated security testing on pull requests

## Results & Outcomes

The DevSecOps transformation delivered exceptional compliance and operational results:

### Compliance Achievements
- **HIPAA Compliance**: 100% compliance with all requirements
- **Audit Findings**: Reduced from 15 critical to 0 critical issues
- **Security Incidents**: Zero data breaches or compliance violations
- **Certification**: Achieved SOC 2 Type II certification

### Operational Improvements
- **Release Lead Time**: Reduced by 72% (from 2 weeks to 3 days)
- **Incident Drill Time**: Decreased by 50% through automation
- **Security Reviews**: Automated 90% of manual security checks
- **Deployment Frequency**: Increased from monthly to weekly releases

### Business Impact
- **Customer Trust**: 25% improvement in customer satisfaction scores
- **Regulatory Confidence**: Passed all external audits on first attempt
- **Operational Efficiency**: 60% reduction in compliance-related overhead
- **Risk Mitigation**: Eliminated all high-risk security findings

## Technology Stack

- **CI/CD**: GitHub Actions with custom security workflows
- **Security Scanning**: Trivy, Dockle, Snyk, SonarQube
- **Policy Engine**: OPA/Conftest for infrastructure policies
- **Secrets Management**: AWS KMS, HashiCorp Vault
- **SBOM Generation**: CycloneDX, Snyk for dependency tracking
- **Deployment**: ArgoCD with automated security gates
- **Monitoring**: Prometheus, Grafana, ELK Stack

## Key Metrics

- **HIPAA Compliance**: 100% compliance maintained for 12 months
- **Security Incidents**: 0 critical, 0 high-severity
- **Release Velocity**: 72% improvement in deployment frequency
- **Audit Success**: 100% pass rate on external compliance audits
- **Cost Optimization**: 40% reduction in compliance-related costs

This case study demonstrates how proper DevSecOps practices, automated security controls, and compliance-first design can transform healthcare platforms into secure, compliant, and efficient systems.`,
    category: 'security',
    client: 'Healthcare Technology Company',
    challenge: 'Audits failing for change control & secrets; slow releases.',
    solution: 'Pipeline gates (SAST, SCA, IaC scanning), ephemeral envs, DAST on PRs, SBOMs, KMS-backed secrets; audit trails.',
    outcome: 'Release lead time −72%, audit findings → 0 critical; incident drill time −50%.',
    technologies: ['GitHub Actions', 'Trivy', 'Dockle', 'OPA/Conftest', 'snyk/cyclonedx', 'ArgoCD'],
    image: '/images/case-studies/healthcare-hipaa-compliance.jpg',
    slug: 'healthcare-hipaa-devsecops',
    publishedAt: '2024-02-20'
  },
  {
    id: 'retail-botnet-defense',
    title: 'Botnet Mitigation & API Abuse Defense for Retail',
    description: 'Comprehensive botnet defense and incident response for high-traffic retail platform.',
    content: `# Botnet Mitigation & API Abuse Defense for Retail

## The Challenge

A global e-commerce brand was experiencing severe botnet attacks and API abuse that threatened their business operations. The platform handled over 10 million daily transactions but faced critical security challenges:

- **Credential stuffing attacks** targeting user accounts
- **Cart abuse spikes** during high-demand periods
- **API rate limit bypasses** causing service degradation
- **Fraudulent transactions** impacting revenue and customer trust

The platform needed a comprehensive defense strategy that would protect against sophisticated botnet attacks while maintaining legitimate user experience.

## Our Approach

We implemented a multi-layered defense system with adaptive security controls:

### 1. Device Fingerprinting & Behavioral Analysis
- **Device Intelligence**: Unique device identification and tracking
- **Behavioral Patterns**: Machine learning models for user behavior analysis
- **Risk Scoring**: Real-time risk assessment for each request
- **Adaptive Authentication**: Dynamic security based on risk levels

### 2. Advanced Rate Limiting & Traffic Management
- **Dynamic Rate Limits**: Per-user and per-route rate limiting
- **IP Reputation**: Real-time IP reputation checking and blocking
- **Geolocation Filtering**: Geographic-based access controls
- **Traffic Shaping**: Intelligent traffic management during peak loads

### 3. Bot Detection & Mitigation
- **hCaptcha Integration**: Advanced CAPTCHA for suspicious traffic
- **WAF Rules**: Custom AWS WAF rules for bot detection
- **Circuit Breakers**: Automatic service protection during attacks
- **Adaptive JWT TTLs**: Dynamic token expiration based on risk

## Results & Outcomes

The comprehensive defense system delivered exceptional security and business results:

### Security Improvements
- **Fraud Attempts**: Reduced by 91% through advanced detection
- **Bot Traffic**: Blocked 99.7% of malicious bot requests
- **API Abuse**: Eliminated 95% of rate limit bypass attempts
- **Security Incidents**: Zero successful attacks in 6 months

### Business Impact
- **Checkout Success Rate**: Increased by 12% through reduced friction
- **Infrastructure Costs**: Reduced by 18% through efficient traffic management
- **Customer Satisfaction**: 20% improvement in user experience scores
- **Revenue Protection**: Prevented $2.3M in fraudulent transactions

### Operational Efficiency
- **Response Time**: Automated 95% of security responses
- **False Positives**: Reduced by 85% through improved detection
- **Monitoring Overhead**: 60% reduction in manual security monitoring
- **Incident Resolution**: 75% faster resolution of security incidents

## Technology Stack

- **WAF**: AWS WAF with custom bot detection rules
- **Caching**: Redis for real-time risk scoring and rate limiting
- **Machine Learning**: Custom ML models for behavioral analysis
- **CAPTCHA**: hCaptcha for advanced bot detection
- **Monitoring**: Prometheus, Grafana for real-time metrics
- **Logging**: ELK Stack for comprehensive security logging
- **CDN**: CloudFront with geographic filtering

## Key Metrics

- **Fraud Prevention**: 91% reduction in fraudulent transactions
- **Bot Detection**: 99.7% accuracy in bot traffic identification
- **Performance Impact**: <50ms additional latency for security checks
- **False Positive Rate**: <0.1% for legitimate user requests
- **Cost Optimization**: 18% reduction in infrastructure costs

## Lessons Learned

### 1. Adaptive Security is Key
Static security controls are easily bypassed. Adaptive, risk-based security that evolves with threats is essential for modern e-commerce platforms.

### 2. User Experience Matters
Security measures must balance protection with user experience. Advanced detection should be invisible to legitimate users.

### 3. Real-time Response is Critical
Automated response systems that can react to threats in real-time are essential for preventing successful attacks.

### 4. Comprehensive Monitoring
End-to-end visibility into traffic patterns, user behavior, and security events is crucial for effective defense.

This case study demonstrates how a comprehensive, adaptive security approach can protect high-traffic e-commerce platforms from sophisticated botnet attacks while maintaining excellent user experience and business performance.`,
    category: 'security',
    client: 'Global E-commerce Brand',
    challenge: 'Credential stuffing & cart abuse spikes.',
    solution: 'Device fingerprinting, IP reputation, dynamic rate limits per user/route, hCaptcha, WAF rules, downstream circuit breakers; adaptive JWT TTLs.',
    outcome: 'Fraud attempts −91%, checkout success +12%, infra cost −18%.',
    technologies: ['AWS WAF', 'Redis', 'Machine Learning', 'hCaptcha', 'Prometheus', 'ELK Stack'],
    image: '/images/case-studies/retail-botnet-defense.jpg',
    slug: 'retail-botnet-incident-response',
    publishedAt: '2024-03-10'
  }
]

export const blogPosts: BlogPost[] = [
  {
    id: 'shift-left-without-shipping-risk',
    title: 'Shift-Left Without Shipping Risk',
    description: 'How to implement early security practices without slowing down development velocity.',
    content: '# Shift-Left Without Shipping Risk\n\n## The Security-Development Paradox\n\nEvery engineering team faces the same fundamental tension: how do you ship fast without shipping vulnerabilities? The traditional approach of bolting security on at the end of the development cycle is both ineffective and expensive. But implementing security early often feels like it will slow down development.\n\nThe solution isn\'t to choose between speed and security—it\'s to make security an integral part of the development process that actually accelerates delivery.',
    author: {
      name: 'DevSecRoot Engineering',
      avatar: '/images/team/devsecroot-engineering.jpg',
      bio: 'Senior Engineering Team at DevSecRoot'
    },
    tags: ['shift-left', 'security', 'devops', 'cicd', 'sdlc'],
    image: '/images/insights/shift-left-security.jpg',
    slug: 'shift-left-without-shipping-risk',
    publishedAt: '2024-01-20',
    readingTime: 8
  },
  {
    id: 'api-security-bola-to-abac',
    title: 'From BOLA to ABAC: Modern API Security Patterns',
    description: 'How to evolve from basic authorization to attribute-based access control for robust API security.',
    content: '# From BOLA to ABAC: Modern API Security Patterns\n\n## The API Security Evolution\n\nAPIs have become the backbone of modern applications, but their security has lagged behind their adoption. The OWASP API Security Top 10 consistently ranks Broken Object Level Authorization (BOLA) as one of the most critical vulnerabilities, affecting 94% of APIs tested.\n\nThe problem isn\'t just technical—it\'s architectural. Most APIs start with simple role-based access control (RBAC) and never evolve beyond it, leaving them vulnerable to sophisticated attacks.',
    author: {
      name: 'DevSecRoot Engineering',
      avatar: '/images/team/devsecroot-engineering.jpg',
      bio: 'Senior Engineering Team at DevSecRoot'
    },
    tags: ['api-security', 'authorization', 'bola', 'abac', 'opa'],
    image: '/images/insights/api-security-patterns.jpg',
    slug: 'api-security-bola-to-abac',
    publishedAt: '2024-02-15',
    readingTime: 12
  },
  {
    id: 'kubernetes-hardening-runtime',
    title: 'Kubernetes Hardening from Build to Runtime',
    description: 'Comprehensive security hardening strategy for Kubernetes clusters from container build to runtime protection.',
    content: '# Kubernetes Hardening from Build to Runtime\n\n## The Kubernetes Security Challenge\n\nKubernetes has become the de facto standard for container orchestration, but with great power comes great responsibility—especially when it comes to security. A misconfigured Kubernetes cluster can expose your entire infrastructure to attackers.\n\nThe challenge isn\'t just technical—it\'s operational. Kubernetes security requires a comprehensive approach that spans the entire lifecycle, from how you build containers to how you monitor runtime behavior.',
    author: {
      name: 'DevSecRoot Engineering',
      avatar: '/images/team/devsecroot-engineering.jpg',
      bio: 'Senior Engineering Team at DevSecRoot'
    },
    tags: ['kubernetes', 'security', 'containers', 'devops', 'runtime'],
    image: '/images/insights/kubernetes-hardening.jpg',
    slug: 'kubernetes-hardening-runtime',
    publishedAt: '2024-03-05',
    readingTime: 15
  },
  {
    id: 'observability-that-prevents-incidents',
    title: 'Observability That Prevents Incidents (Not Just Explains Them)',
    description: 'How to build observability systems that proactively prevent incidents rather than just helping you debug them.',
    content: '# Observability That Prevents Incidents (Not Just Explains Them)\n\n## The Observability Paradox\n\nMost teams think of observability as a post-incident tool—something you use to figure out what went wrong after your system is already broken. But the real power of observability lies in its ability to prevent incidents from happening in the first place.\n\nThe difference between reactive and proactive observability is the difference between firefighting and fire prevention. Both are important, but one is significantly more valuable.',
    author: {
      name: 'DevSecRoot Engineering',
      avatar: '/images/team/devsecroot-engineering.jpg',
      bio: 'Senior Engineering Team at DevSecRoot'
    },
    tags: ['observability', 'monitoring', 'sre', 'incidents', 'slo'],
    image: '/images/insights/observability-prevention.jpg',
    slug: 'observability-that-prevents-incidents',
    publishedAt: '2024-03-25',
    readingTime: 11
  }
]

export const testimonials: Testimonial[] = [
  {
    id: 'testimonial-1',
    name: 'Jennifer Martinez',
    role: 'CTO',
    company: 'TechFlow Solutions',
    content: 'DevSecRoot transformed our security posture. Their comprehensive assessment identified critical vulnerabilities we had missed, and their remediation guidance was clear and actionable.',
    avatar: '/images/testimonials/jennifer-martinez.jpg',
    rating: 5
  },
  {
    id: 'testimonial-2',
    name: 'Robert Chen',
    role: 'VP Engineering',
    company: 'SecureBank',
    content: 'The microservices architecture they designed for us handles 10x the traffic with 99.9% uptime. Their expertise in both security and development is unmatched.',
    avatar: '/images/testimonials/robert-chen.jpg',
    rating: 5
  },
  {
    id: 'testimonial-3',
    name: 'Amanda Foster',
    role: 'Security Director',
    company: 'HealthTech Inc',
    content: 'Achieving HIPAA compliance seemed impossible until we worked with DevSecRoot. Their systematic approach and deep expertise made it straightforward.',
    avatar: '/images/testimonials/amanda-foster.jpg',
    rating: 5
  }
]

export const stats: Stats[] = [
  {
    label: 'Applications Secured',
    value: '100+',
    description: 'Web and mobile applications protected'
  },
  {
    label: 'Incident Response Time',
    value: '<24h',
    description: 'Average triage and response time'
  },
  {
    label: 'Vulnerabilities Found',
    value: '500+',
    description: 'Critical and high-risk issues identified'
  },
  {
    label: 'Client Satisfaction',
    value: '98%',
    description: 'Based on post-engagement surveys'
  }
]

export const timelineSteps: TimelineStep[] = [
  {
    id: 'discover',
    title: 'Discover',
    description: 'Understand your business needs, current architecture, and security requirements.',
    icon: 'Search'
  },
  {
    id: 'assess-design',
    title: 'Assess & Design',
    description: 'Conduct security assessments or design scalable, secure architectures.',
    icon: 'PenTool'
  },
  {
    id: 'implement',
    title: 'Implement',
    description: 'Build, test, and deploy secure solutions with best practices.',
    icon: 'Code'
  },
  {
    id: 'monitor',
    title: 'Monitor',
    description: 'Ongoing monitoring, maintenance, and security updates.',
    icon: 'Activity'
  }
]

export const features: Feature[] = [
  {
    title: 'Cutting-edge Technology',
    description: 'We leverage the latest security tools and development frameworks to deliver superior results.',
    icon: 'Zap'
  },
  {
    title: 'Proven Methodologies',
    description: 'Industry-standard approaches combined with our proprietary security testing methodologies.',
    icon: 'Shield'
  },
  {
    title: 'Passion for Innovation',
    description: 'Constantly evolving our practices to stay ahead of emerging threats and technologies.',
    icon: 'Lightbulb'
  }
]

export const navigation: { main: NavItem[]; footer: FooterLink[]; social: SocialLink[] } = {
  main: [
    { label: 'Services', href: '/services' },
    { label: 'Security', href: '/security' },
    { label: 'Development', href: '/development' },
    { label: 'Case Studies', href: '/case-studies' },
    { label: 'Insights', href: '/insights' },
    { label: 'About', href: '/about' },
    { label: 'Careers', href: '/careers' },
    { label: 'Contact', href: '/contact' }
  ],
  footer: [
    { label: 'Privacy Policy', href: '/privacy' },
    { label: 'Terms of Service', href: '/terms' },
    { label: 'Cookie Policy', href: '/cookies' }
  ],
  social: [
    { name: 'GitHub', href: 'https://github.com/devsecroot', icon: 'Github' },
    { name: 'LinkedIn', href: 'https://linkedin.com/company/devsecroot', icon: 'Linkedin' },
    { name: 'X (Twitter)', href: 'https://x.com/devsecroot', icon: 'Twitter' }
  ]
}
